mutation updateSavedContent($input: UpdateSavedContentInput!) {
  savedContent: updateSavedContent(input: $input)
}
